import { Dropdown } from 'antd';
import classNames from 'classnames';
import Icon from '../../icons';
import { CustomFilterProps } from '../../interfaces';
import '../../styles.scss';
import { ContentWrapper, QuantityWrapper } from './styles';
import './styles.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropdownArrow from '../DropdownArrow';

const CustomFilter: React.FC<CustomFilterProps> = props => {
  const { t } = useTranslation();
  const {
    menu,
    open,
    onOk,
    width,
    options,
    quantity,
    disabled,
    onCancel,
    className,
    onOpenChange,
    dropdownRender,
    trigger = ['click'],
    placement = 'bottomRight',
    defaultOverlayWidth = true,
    quantityWidth = 'fit-content',
    children = t('common.filters'),
    icon = <Icon name="filter" color="white" />,
    ...rest
  } = props;

  const [isOpen, setIsOpen] = useState(open || false);

  useEffect(() => {
    setIsOpen(open ?? isOpen);
  }, [open, isOpen]);

  return (
    <Dropdown
      {...rest}
      menu={menu}
      open={open}
      trigger={trigger}
      disabled={disabled}
      placement={placement}
      dropdownRender={dropdownRender}
      overlayClassName={classNames(
        'custom-filter-dropdown',
        defaultOverlayWidth ? 'default-width' : '',
      )}
      className={classNames(className, 'custom-filter')}
      onOpenChange={e => {
        setIsOpen(e);
        onOpenChange?.(e);
      }}
    >
      <ContentWrapper className={classNames({ disabled })}>
        {icon}
        {children}
        <QuantityWrapper>
          <span style={{ width: quantityWidth }}>{quantity}</span>

          <DropdownArrow open={isOpen} />
        </QuantityWrapper>
      </ContentWrapper>
    </Dropdown>
  );
};

export default CustomFilter;
